var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.heading)?_c('div',{class:{ 'border-above': _vm.isAbove, 'border-below': _vm.isBelow }},[_c('h3',{staticClass:"bgfunds-heading",staticStyle:{"border":"none"}},[_vm._v(_vm._s(_vm.heading))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }